export default __webpack_public_path__ + "media/titles/title_1_locale_nl-ded5bd32.png";